import React, { useEffect, useState, useRef } from "react"
import DataTable from "../../../components/atoms/table/DataTable.atom"
import Column from "../../../components/atoms/table/Column.atom"
import Card from "../../../components/atoms/Card.atom"
import VacationTitle from "../components/VacationTitle.compound"
import { getTeamMemberInfo } from "../../../services/teamMember.service"
import TeamMembersContextMenu from "./teamMembersContextMenu.controller"
import TeamMembersActionModal from "./teamMembersActionModal.controller"
import statusFilterElement from "../../../components/compounds/columnFilters/StatusFilter.compond"
import { TEAM_MEMBER_TABLE_DEFAULT_FILTER } from "../../../consts/modules/teamMembers.consts"
import { getNumberOfDaysSinceTodayAsString } from "../../../utils/date.utils"
import useToast from "../../../hooks/useToast.hook"

const TeamMembersTable = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const { setErrorMessage } = useToast()

  const [filter, setFilter] = useState(1)
  const [datatableFilter, setDatatableFilter] = useState(
    TEAM_MEMBER_TABLE_DEFAULT_FILTER
  )
  const filterApplyCallbackRef = useRef()

  const cmRef = useRef()

  useEffect(() => {
    gettingTeamMemberInfo()
  }, [])

  const gettingTeamMemberInfo = async () => {
    setLoading(true)
    try {
      const response = await getTeamMemberInfo()
      if (!response.success) {
        throw new Error(response.message)
      }
      setData(response.result)
    } catch (error) {
      setErrorMessage({
        message: "Ha ocurrido un error al obtener los integrantes.",
      })
    }
    setLoading(false)
  }

  useEffect(() => {
    if (refresh) {
      gettingTeamMemberInfo()
      setRefresh(false)
    }
  }, [refresh])

  const rowClass = (data) => {
    if (data.active === 0) return "disabled-row"
  }

  return (
    <Card id="team-member-table" className="p-1 shadow-none">
      <DataTable
        value={data}
        filters={datatableFilter}
        responsiveLayout="scroll"
        scrollable
        style={{ height: "100%" }}
        scrollHeight="100%"
        rowClassName={rowClass}
        loading={loading}
        loadingConfig={{ qtyOfRows: 15 }}
      >
        <Column field="fullName" header="Nombre" sortable frozen />
        <Column
          field="jobTitle"
          body={(node) => <span>{node?.jobTitle ? node?.jobTitle : ""}</span>}
          header="Puesto"
          sortable
          style={{ maxWidth: "194px" }}
        />
        <Column
          field="workAnniversary"
          body={(node) => (
            <span>
              {getNumberOfDaysSinceTodayAsString(node?.workAnniversary)}
            </span>
          )}
          header="Antigüedad"
          sortable
          style={{ maxWidth: "194px" }}
        />
        <Column
          field="holidaySchemaName"
          body={(node) => (
            <VacationTitle schemaTitle={node?.holidaySchemaName} />
          )}
          header="Esquema de vacaciones"
          sortable
          style={{ maxWidth: "214px" }}
        />
        <Column
          field="active"
          body={(node) => (
            <span>{node?.active === 0 ? "Inactivo" : "Activo"}</span>
          )}
          header="Estatus"
          filter
          filterField="active"
          showFilterMatchModes={false}
          showFilterMenuOptions={false}
          filterElement={(options) =>
            statusFilterElement({
              options,
              filterApplyCallbackRef,
              onChange: (e) => setFilter(e.value),
            })
          }
          filterMatchMode="equals"
          onFilterClear={() => setFilter(null)}
          onFilterApplyClick={() => {
            setDatatableFilter({
              active: {
                value: filter,
                matchMode: "equals",
              },
            })
          }}
          style={{ maxWidth: "114px" }}
        />
        <Column
          style={{ maxWidth: "70px", padding: 0 }}
          body={(node) => {
            return (
              <i
                className="pi pi-ellipsis-v cursor-pointer"
                onClick={(event) => {
                  cmRef?.current?.show(event)
                  setSelectedRow({
                    ...node,
                    id: node?.userId,
                    active: node?.active,
                  })
                }}
              />
            )
          }}
        />
      </DataTable>
      <TeamMembersContextMenu
        selectedRow={selectedRow}
        ref={cmRef}
        setOpenModal={setOpenModal}
        setRefresh={setRefresh}
      />
      <TeamMembersActionModal
        row={selectedRow}
        visible={openModal}
        setVisible={setOpenModal}
        onFinishedSubmit={() => {
          setSelectedRow(null)
          setRefresh(true)
        }}
      />
    </Card>
  )
}

export default TeamMembersTable
